// 轮播图模块展示映射（枚举/中文标签；数据已走后端 /banner* 接口）
// 对齐 docs/项目数据库文档.md 的 tb_banner 表（13 字段 + 表尾四件套）
// link_type 是 TINYINT 0~7（项目原本有"枚举统一放字典"的约定，但 doc 这里写死 TINYINT，
// 按 doc 建表；后续接后端保持一致）

// 跳转类型枚举：0 不跳 / 1 活动 / 2 官方内容 / 3 景区 / 4 旅居基地 / 5 帖子 / 6 H5 外链 / 7 小程序内页
// 业务含义看 docs/项目数据库文档.md 的 tb_banner.link_type 字段说明
export const BANNER_LINK_TYPE = [
  { value: 0, label: '不跳转' },
  { value: 1, label: '活动详情' },
  { value: 2, label: '官方内容' },
  { value: 3, label: '景区详情' },
  { value: 4, label: '旅居基地' },
  { value: 5, label: '社区帖子' },
  { value: 6, label: 'H5 外链' },
  { value: 7, label: '小程序内页' }
]

// 状态：0 下架 / 1 上架（与 doc 一致；不用 tagType，0=info 灰，1=success 绿）
export const BANNER_STATUS = [
  { value: 1, label: '上架' },
  { value: 0, label: '下架' }
]

// ===== 辅助函数 =====

// 跳转类型 → 中文标签
export function bannerLinkTypeLabel(value) {
  const item = BANNER_LINK_TYPE.find(t => t.value === value)
  return item ? item.label : '未知'
}

// 状态 → 中文
export function bannerStatusText(value) {
  const item = BANNER_STATUS.find(s => s.value === value)
  return item ? item.label : '未知'
}

// 状态 → 表格 tagType
export function bannerStatusTagType(value) {
  // 1 上架=success 绿，0 下架=info 灰
  return value === 1 ? 'success' : 'info'
}

// 跳转值展示：type 1 → "活动 #12"；type 6 → 直接 URL；type 0 → "—"
export function bannerLinkValueText(row) {
  if (row.link_type === 0) return '—'
  if (!row.link_value) return '(空)'
  if (row.link_type === 1) return `活动 #${row.link_value}`
  if (row.link_type === 2) return `内容 #${row.link_value}`
  if (row.link_type === 3) return `景区 #${row.link_value}`
  if (row.link_type === 4) return `基地 #${row.link_value}`
  if (row.link_type === 5) return `帖子 #${row.link_value}`
  // 6 H5 / 7 小程序路径：直接展示
  return row.link_value
}
